import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  alertContainer: {
    position: 'fixed',
    right: 10,
    top: 35,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    '& .MuiAlert-standardSuccess': {
      backgroundColor: '#0E9F6E',
      color: theme.palette.text.secondary,
    },
    '& .MuiAlert-standardInfo': {
      backgroundColor: '#2C72DB',
      color: theme.palette.text.secondary,
    },
    '& .MuiAlert-message': {
      fontWeight: 400,
      fontSize: '14px',
      fontFamily: 'Inter, sans-serif',
    },
  },
}))
